import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/laser.png';
import './Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__glow" />
      <div className="container footer__inner">

        {/* Brand */}
        <div className="footer__brand">
          <Link to="/" className="footer__logo">
            <img
              src={logo}
              alt="LaserGuided Solutions Logo"
              className="footer__logo-img"
            />
            <div>
              <div className="footer__logo-name">LaserGuided</div>
              <div className="footer__logo-sub">Solutions</div>
            </div>
          </Link>
          <p className="footer__tagline"><em>Target your success with accuracy</em></p>
          <p className="footer__desc">
            Precision-engineered digital solutions for ambitious businesses.
            Built in Kenya, deployed worldwide.
          </p>
          <div className="footer__socials">
            {[
              { name: 'LinkedIn', href: '#' },
              { name: 'Twitter', href: '#' },
              { name: 'GitHub', href: '#' },
              { name: 'Instagram', href: '#' },
            ].map(s => (
              <a key={s.name} href={s.href} className="footer__social" aria-label={s.name}>{s.name[0]}</a>
            ))}
          </div>
        </div>

        {/* Links */}
        <div className="footer__links-group">
          <h4>Services</h4>
          <ul>
            {['Web Development', 'Systems Development', 'App Development', 'UI/UX Design', 'Digital Strategy', 'Maintenance & Support'].map(s => (
              <li key={s}><Link to="/services">{s}</Link></li>
            ))}
          </ul>
        </div>

        <div className="footer__links-group">
          <h4>Company</h4>
          <ul>
            {[
              { label: 'Home', to: '/' },
              { label: 'About Us', to: '/about' },
              { label: 'Portfolio', to: '/portfolio' },
              { label: 'Contact', to: '/contact' },
            ].map(l => (
              <li key={l.to}><Link to={l.to}>{l.label}</Link></li>
            ))}
          </ul>
        </div>

        <div className="footer__links-group">
          <h4>Contact</h4>
          <ul className="footer__contact-list">
            <li>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
              </svg>
              Eldoret, Kenya
            </li>
            <li>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
              </svg>
              info@laserguided.co.ke
            </li>
            <li>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2.18h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
              </svg>
              +254 743 379 990
            </li>
            <li>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
              </svg>
              Mon–Fri, 8am – 4pm EAT
            </li>
          </ul>
        </div>

      </div>

      <div className="footer__bottom">
        <div className="container footer__bottom-inner">
          <div className="footer__copy">
            © {year} LaserGuided Solutions. All rights reserved.
          </div>
          <div className="footer__legal">
            <a href="#">Privacy Policy</a>
            <a href="#">Terms of Service</a>
          </div>
          <div className="footer__made">
            Made with precision in 🇰🇪
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;